<p-dialog [(visible)]="displayDialog" [modal]="true"  [style]="{ 'width': '650px', 'min-height':'620px'}" (onHide)="cancel()">
  <ng-template pTemplate="header">
    <div class="w-full text-center font-22 font-weight-600" translate>savings.interest_adjust</div>
  </ng-template>

  <div class="">
    <form #form="ngForm" (ngSubmit)="onSave()">
      <div class="">
        <div class="m-auto col-11">
          <div class="row form-input-row">
            <div class="col-5 text-right" translate>orders.document_number<span class="requireSym">*</span>
          </div>
          <div class="col-7">
            <input type="text" name="documentNumber" class="form-control" placeholder=""
              [(ngModel)]="savingAgreementInterestAdjustment.documentNumber" id="documentNumber" #documentNumber="ngModel" required>
              <small class="text-danger">
                {{documentNumber.valid || !submittedForm ? '' : 'This field is required'}}
              </small>
            </div>
          </div>
          <div class="row form-input-row">
            <div class="col-5 text-right" translate>savings.title<span class="requireSym">*</span>
          </div>
          <div class="col-7">
            <input type="text" name="savingAgreement" class="form-control" placeholder=""
              [(ngModel)]="savingAgreementInterestAdjustment.agreementNumber" id="savingAgreement" #savingAgreementRef="ngModel" readonly>
              <small class="text-danger">
                {{savingAgreementRef.valid || !submittedForm ? '' : 'This field is required'}}
              </small>
            </div>
          </div>
          <div class="row form-input-row">
            <div class="col-5 text-right" translate>common.date<span class="requireSym">*</span>
          </div>
          <div class="col-7">
            <p-calendar class="w-full" [showIcon]="true" dataType="string"
              [(ngModel)]="savingAgreementInterestAdjustment.date" dateFormat="dd-mm-yy" [style]="{'width':'100%'}"
              [inputStyle]="{'width':'90%'}" name="date" required [monthNavigator]="true"
              [yearNavigator]="true" [yearRange]="yearRange" #dateRef="ngModel" [showOnFocus]="false"
              (ngModelChange)="getSavingAgreementInterestAdjustment()" [ngClass]="'custom-calendar'">
            </p-calendar>
            <small class="text-danger">
              {{dateRef.valid || !submittedForm ? '' : 'This field is required'}}
            </small>
          </div>
        </div>
        <div class="row form-input-row">
          <div class="col-5 text-right" translate>common.amount<span class="requireSym">*</span>
        </div>
        <div class="col-7">
          <div class="field-group">
            <app-input-number-format type="text" style="width:100%" [allowNegative] = "true"
              name="interestAmount" placeholder="" className="form-control w-full"
              [value]="savingAgreementInterestAdjustment.interestAmount"
              (onCommitChangeValue)="onAmountChange($event)">
            </app-input-number-format>
            @if (selectedCurrency) {
              <span class="base-currency-box">{{selectedCurrency}}</span>
            }
          </div>
          <div class="d-flex align-items-center">
            <small class="text-danger">
              {{(savingAgreementInterestAdjustment.interestAmount != null && savingAgreementInterestAdjustment.interestAmount != undefined) || !submittedForm ? '' : 'This field is required'}}
            </small>
            <small id="account-late" class="outstanding">
              <span translate>accounts.interest_amount</span>: <span class="outstanding-value">{{formatNumber(savingAgreementInterestAdjustment?.customerSpecificOptions[0]?.interestAmount)}}</span>
            </small>
          </div>
        </div>
      </div>
      <div class="row form-input-row">
        <div class="col-5 text-right" translate>common.branch<span class="requireSym">*</span>
      </div>
      <div class="col-7">
        <p-dropdown [options]="branches" name="branch" id="branch"
          [(ngModel)]="adjustmentBranchId" placeholder="Select a branch "
          optionLabel="name" optionValue="id" #branchRef="ngModel" required class="w-full"
          [style]="{'width': '100%'}">
        </p-dropdown>
        <small class="text-danger">
          {{branchRef.valid || !submittedForm ? '' : 'This field is required'}}
        </small>
      </div>
    </div>
  </div>

  <div class="form-input-row pt-20">
    <div class="d-flex justify-content-center">
      <app-button id ="interest-calculate" buttonClass="btn-primary"
        buttonType="button" (clickEvent)="onSave()"
        [isDisabled]="!savingAgreementInterestAdjustment.interestAmount || savingAgreementInterestAdjustment.interestAmount === 0">
        <span translate>buttons.save</span>
      </app-button>
      <app-button id="btn-cancel-savings" buttonClass="btn-secondary mr-0"
        buttonType="button" (clickEvent)="cancel()">
        <span translate>buttons.cancel</span>
      </app-button>

    </div>
  </div>
</div>
</form>
</div>
</p-dialog>